var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKatalonPlatformColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 36,
    viewBox: "0 0 152 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6ogqxns7fa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m45.825 18.608 9.653-12.624h4.925L52.51 16.242l7.99 13.773h-4.828l-5.905-10.224-3.945 5.094v5.127h-4.175V5.984h4.175v12.624h.004zM61.843 25.38c0-2.991 2.154-4.865 5.97-5.162l4.829-.362v-.362c0-2.203-1.303-3.09-3.328-3.09-2.348 0-3.655.988-3.655 2.696h-3.392c0-3.517 2.872-5.818 7.24-5.818 4.369 0 7.011 2.366 7.011 6.87v9.864h-3.49l-.294-2.4c-.685 1.676-2.872 2.826-5.38 2.826-3.425 0-5.515-2.004-5.515-5.061h.004zm10.83-1.938v-.854l-3.36.264c-2.48.232-3.424 1.053-3.424 2.366 0 1.48.98 2.204 2.771 2.204 2.445 0 4.014-1.48 4.014-3.976v-.004zM81.706 30.015V17.128h-3.098v-3.354h3.098V8.712h3.977v5.062h3.13v3.354h-3.13v12.887h-3.977zM90.483 25.38c0-2.991 2.154-4.865 5.97-5.162l4.829-.362v-.362c0-2.203-1.303-3.09-3.328-3.09-2.348 0-3.655.988-3.655 2.696h-3.392c0-3.517 2.872-5.818 7.24-5.818 4.369 0 7.012 2.366 7.012 6.87v9.864h-3.49l-.294-2.4c-.686 1.676-2.872 2.826-5.381 2.826-3.425 0-5.515-2.004-5.515-5.061h.004zm10.831-1.938v-.854l-3.36.264c-2.48.232-3.425 1.053-3.425 2.366 0 1.48.98 2.204 2.772 2.204 2.444 0 4.013-1.48 4.013-3.976v-.004zM109.14 30.015V5.558h3.946v24.457h-3.946zM124.929 13.319c4.99 0 8.612 3.484 8.612 8.545 0 5.062-3.622 8.546-8.612 8.546s-8.612-3.484-8.612-8.546c0-5.061 3.622-8.546 8.612-8.546zm0 13.51c2.739 0 4.631-2.005 4.631-4.965s-1.892-4.964-4.631-4.964c-2.739 0-4.631 2.005-4.631 4.964 0 2.96 1.892 4.964 4.631 4.964zM136.704 30.015V13.779h3.687l.326 2.106c1.013-1.643 2.969-2.598 5.156-2.598 4.046 0 6.131 2.533 6.131 6.74v9.994h-3.977v-9.042c0-2.728-1.339-4.045-3.393-4.045-2.444 0-3.945 1.707-3.945 4.338v8.744h-3.985z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.816 23.999H11.908V36h11.908V23.999z",
    fill: "#19D89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.908 0 0 12.001v12.002h11.908L23.812 12V0H11.908z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6ogqxns7fa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h152v36H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKatalonPlatformColor);
export default __webpack_public_path__ + "static/media/katalon-platform-color.038ccf7a28c59f0ecef015760d4bf380.svg";
export { ForwardRef as ReactComponent };